import React, { useEffect, useState } from "react";
import DeviceContext from "./customHooks/indentifyDevice";
import {
  alphanumericAndSpacesOnly,
  alphanumericOnlyWithoutSpecialChar,
} from "@/utils/regex";

interface ISearchBar {
  openInputBackground: string;
  searchBarBackground: string;
  iconColors: string;
  deskPlaceHolder?: string;
  mobPlaceHolder?: string;
  parentClassName?: string;
  onCallbackFunction?: Function;
  onClose?: Function;
  onBack?: Function;
  searchKey?: string;
  defaultValue?: string;
  disabled?: boolean;
  onFocus?: Function;
  onBlur?: Function;
  autoComplete?: string;
  focusOnLoad?: boolean;
  setOnFocusa?: Function;
  onClickBack?: Function;
  onFocusa?: boolean;
  specialCharNotAllowed?: boolean;
  searchRef?: React.MutableRefObject<any>;
}
const SearchBar = (props: ISearchBar) => {
  const device = DeviceContext();
  const [openSearch, setOpenSearch] = useState(
    props?.focusOnLoad ? props?.focusOnLoad : false,
  );
  const [searchValue, setSearchValue] = useState<string>(
    props?.defaultValue ? props?.defaultValue : "",
  );

  const handleBlur = () => {
    if (!searchValue) setSearchValue("");
    setOpenSearch(false);
    props.onBlur && props.onBlur();
  };

  // useEffect(() => {
  //   if (props.onCallbackFunction ) {
  //     props.onCallbackFunction(searchValue);
  //   }
  // }, [searchValue, props.defaultValue]);

  useEffect(() => {
    if (searchValue != props.searchKey) {
      setSearchValue(props.searchKey);
    }
  }, [props.searchKey]);
  useEffect(() => {
    if (props.onCallbackFunction && props?.searchKey) {
      props.onCallbackFunction(props.searchKey);
    }
  }, [props?.searchKey]);

  useEffect(() => {
    if (props?.setOnFocusa) {
      props?.onFocusa === false && setSearchValue("");
    }
  }, [props?.onFocusa]);

  return (
    <div className={props.parentClassName ? props.parentClassName : ""}>
      <div
        className={`common-search-bar d-flex align-items-center ${
          props.searchBarBackground
        } ${
          (openSearch || (props?.setOnFocusa ? props?.onFocusa : false)) &&
          "open-search"
        }`}
      >
        {openSearch || (props?.setOnFocusa ? props?.onFocusa : false) ? (
          <label
            htmlFor="focus-input"
            onMouseDown={() => {
              setSearchValue(props?.defaultValue || "");
              props?.onBack && props.onBack();
            }}
          >
            <span className="edel-icon-left-arrow hand_cursor"></span>
          </label>
        ) : (
          //  {/*  <label htmlFor="focus-input">
          //   <span
          //     className="edel-icon-left-arrow hand_cursor"
          //     onClick={() => {
          //       setSearchValue("");
          //       props.onCallbackFunction("");
          //       setOpenSearch(false);
          //       props?.onBack && props.onBack();
          //     }}
          //   ></span>
          // </label>  */}
          <label>
            <i
              className="edel-icon-search1"
              onClick={() => {
                if (props?.disabled) return;
                setOpenSearch(true);
              }}
            ></i>
          </label>
        )}
        <input
          ref={props?.searchRef}
          autoFocus={props?.focusOnLoad}
          autoComplete={props?.autoComplete}
          disabled={props?.disabled}
          className={
            openSearch ? props.openInputBackground : props.searchBarBackground
          }
          id="focus-input"
          type="search"
          placeholder={
            device?.isDesktop ? props.deskPlaceHolder : props.mobPlaceHolder
          }
          value={searchValue}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            props?.setOnFocusa && props?.setOnFocusa(true);
          }}
          onChange={(e) => {
            if (props.specialCharNotAllowed) {
              const sanitizedValue = e.target.value.replace(
                alphanumericAndSpacesOnly,
                "",
              );
              setSearchValue(sanitizedValue);
              props.onCallbackFunction?.(sanitizedValue);
            } else {
              setSearchValue(e.target.value);
              props.onCallbackFunction(e.target.value);
            }
          }}
          onFocus={() => {
            setOpenSearch(true);
            props.onFocus && props?.onFocus();
          }}
          onBlur={handleBlur}
        />
        {openSearch && (
          <label htmlFor="focus-input">
            <i
              className="edel-icon-close txt_secondary-gray hand_cursor"
              onMouseDown={(e) => {
                // props?.setOnFocusa && props?.setOnFocusa(false);
                setSearchValue("");
                props.onCallbackFunction("");
                props.onClose && props.onClose();
              }}
            ></i>
          </label>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
